module.exports = __webpack_public_path__ + "static/media/meter-heat.51429092.svg";